import { render, staticRenderFns } from "./UserActivePermit.vue?vue&type=template&id=3f4498cb&scoped=true"
import script from "./UserActivePermit.vue?vue&type=script&lang=js"
export * from "./UserActivePermit.vue?vue&type=script&lang=js"
import style0 from "./UserActivePermit.vue?vue&type=style&index=0&id=3f4498cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4498cb",
  null
  
)

export default component.exports